import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Check } from 'lucide-react';
import SEO from '../components/SEO';

export default function ThankYou() {
  return (
    <div className="min-h-screen mesh-gradient-light flex items-center justify-center px-6" data-testid="thank-you-page">
      <SEO title="Blueprint Submitted" noindex={true} />
      <div className="max-w-md text-center animate-fade-up">
        <div className="w-16 h-16 rounded-full bg-emerald-50 border border-emerald-200/50 flex items-center justify-center mx-auto mb-8">
          <div className="w-10 h-10 rounded-full bg-emerald-500 flex items-center justify-center">
            <Check className="w-5 h-5 text-white" />
          </div>
        </div>

        <h1 className="text-4xl sm:text-5xl tracking-tight mb-4" style={{ fontFamily: "'Instrument Serif', serif" }}>
          You're all <span className="italic">set</span>
        </h1>
        <p className="text-base text-slate-500 leading-relaxed mb-10">
          Your Burlington Buyer Blueprint has been submitted. A local specialist will review your profile and reach out based on your preferred contact method.
        </p>

        <div className="bg-white rounded-2xl border border-slate-200/80 p-6 text-left mb-10">
          <p className="font-mono text-[10px] text-slate-400 uppercase tracking-widest mb-4">What happens next</p>
          <div className="space-y-4">
            {[
              'Neighbourhood matches are being finalized',
              'A Burlington specialist will review your profile',
              'You\'ll receive your brief via email',
              'Follow-up within 24 hours for high-readiness buyers',
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0">
                  <span className="font-mono text-[10px] font-medium text-slate-500">{i + 1}</span>
                </div>
                <span className="text-sm text-slate-600 pt-0.5">{item}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/neighbourhoods" data-testid="thankyou-explore-btn">
            <Button variant="outline" className="rounded-full px-6 text-sm border-slate-200">
              Explore Neighbourhoods
            </Button>
          </Link>
          <Link to="/" data-testid="thankyou-home-btn">
            <Button className="bg-slate-900 text-white hover:bg-slate-800 rounded-full px-6 text-sm shadow-lg shadow-slate-900/20 hover:-translate-y-px transition-all">
              Back to Home <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
